import { GraphQL } from "@rpi/openapi-api";

export const MIN_PAGE_COUNT = 20;
const MAX_PAGE_COUNT = 380;
const PAGE_STEP = 2;

export type PriceInfo = {
  usd?: GraphQL.OpenapiProductPricing;
  minPageCount: number;
  maxPageCount: number;
  pageIncrement: number;
};

export function getBookPriceInfoUSD(
  openapiProduct?: GraphQL.OpenApiProductWithPricingQuery["openapiProduct"]
): PriceInfo {
  const pagesSpec = openapiProduct?.productSpecification?.specification?.pages_spec;
  const minPageCount = (pagesSpec?.min_page_count as number) ?? MIN_PAGE_COUNT;
  const maxPageCount = (pagesSpec?.max_page_count as number) ?? MAX_PAGE_COUNT;
  const pageIncrement = (pagesSpec?.page_count_mod as number) ?? PAGE_STEP;

  const usd = openapiProduct?.productPricing?.find(
    (productPrice) => productPrice.currency === GraphQL.SupportedCurrency.Usd
  );

  return { usd, minPageCount, maxPageCount, pageIncrement };
}
